import createVueApp from '@/common/create_app'
import sidebar from '@/config/sidebars/reports'

Styxie.Initializers.AuditReports = {
  index: async(props) => {
    const { default: AuditReportsIndex } = await import('@/vue_widgets/audit_reports/index.vue')
    createVueApp(AuditReportsIndex, { props, sidebar })
  },
  show: async(props) => {
    const { default: AuditReportShow } = await import('@/vue_widgets/audit_reports/show/index.vue')
    createVueApp(AuditReportShow, { props, sidebar })
  }
}
